export default "__VITE_ASSET__Bnf$e2EZ__"